export default "__VITE_ASSET__Bg19KEaB__"